/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { TypeMoney } from '../models/TypeMoney';
import { HttpFile } from '../http/http';

/**
* Update or create the cpms of an order line
*/
export class UpdateCPMsRequest {
    /**
    * ID of the Org
    */
    'orgId'?: string;
    /**
    * Map of related costs for this Order Line
    */
    'cpms'?: { [key: string]: TypeMoney; };

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "orgId",
            "baseName": "org_id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "cpms",
            "baseName": "cpms",
            "type": "{ [key: string]: TypeMoney; }",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return UpdateCPMsRequest.attributeTypeMap;
    }

    public constructor() {
    }
}

